<template>
  <div class="pro-home-page overflow-x-hide">
    <div class="container no-padding">
      <headerlogo
        :page-type="'1'"
        :csrf-loaded="true"
        :show-prospect-form="showProspectForm"
      />
      <div
        class="row no-padding main-body h-100"
        :style="{ height: windowHeight }"
      >
        <div class="col-sm-12 col-md-12 row my-auto no-padding no-margin">
          <div
            class="col-sm-12 col-12 col-md-12 row no-padding no-margin"
            style="align-items: center"
          >
            <div
              class="col-sm-12 col-md-4 offset-md-2 text-container tab-container no-padding flex-container"
            >
              <div class="left-content">
                <div id="content-sec1" class="content-sec1">
                  {{ getUiText("app-prospect-landing-heading-1") }}
                </div>
                <div class="content-sec2">
                  {{ getUiText("app-prospect-landing-heading-sub-1") }}
                </div>

                <div
                  v-if="isFailVerified"
                  class="display-flex m-top-47 passphrase content-sec3"
                >
                  <div class="form-group">
                    <label for="passphrase">{{
                      getUiText("app-prospect-landing-preview-heading-1")
                    }}</label>
                    <input
                      id="passphrase"
                      ref="passphraseCodeFeild"
                      v-model="passphrase"
                      data-cy="psp-home-passphrase-input"
                      type="text"
                      autocomplete="false"
                      class="form-control"
                      :placeholder="passphrasePrompt"
                      tabindex="0"
                    />
                  </div>
                </div>
                <div v-if="isFailVerified" class="content-sec4">
                  {{ getUiText("app-prospect-landing-preview-tip-1") }}
                </div>

                <div
                  v-if="
                    !isFailVerified ||
                    (isFailVerified && (passphraseStatus || null))
                  "
                >
                  <div class="display-flex m-top-47 content-sec3">
                    <button
                      id="letsgo"
                      data-cy="psp-home-letsgo-btn"
                      type="button"
                      class="btn btn-primary letsgo-button"
                      @click="letsgo"
                    >
                      {{ getUiText("app-prospect-landing-button-lets-go-1") }}
                    </button>

                    <div
                      v-if="isFailVerified"
                      class="content-sec2-enter-block d-sm-none d-md-block d-none d-sm-block"
                    >
                      <span class="enter-text">{{
                        getUiText("app-nav-press-enter-1")
                      }}</span>
                      <span class="enter-icon"
                        ><img src="@/assets/enter_icon.svg"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 tab-image-container flex-container">
              <img src="@/assets/img/bg3.png" class="img-laptop" />
            </div>
          </div>
        </div>
      </div>

      <div
        class="footer row d-sm-none d-md-block d-none d-sm-block page-footer no-margin"
      >
        {{ getUiText("app-prospect-nav-cms-text-1") }}
        <a href="https://cybersystem.io">{{
          getUiText("app-prospect-nav-cms-link-1")
        }}</a>
      </div>
    </div>

    <errorhandler
      v-if="showProspectCallbackError || null"
      :prospect-callback-error-msg="prospectCallbackErrorMsg"
      @reset-show-prospect-callback-error="resetShowProspectCallbackError"
    />

    <!-- Prospect form  -->
    <div
      id="prospectModal"
      class="modal fade prospect-form"
      tabindex="-1"
      data-bs-backdrop="false"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-close float-right">
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                data-bs-target="#prospectModal"
              >
                <img src="@/assets/img/close.svg" />
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-body-padding">
              <div class="modal-welcome">
                {{ getUiText("app-prospect-landing-verify-heading-1") }}
              </div>
              <div class="modal-sec2">
                {{ getUiText("app-prospect-landing-verify-heading-sub-1") }}
              </div>
              <div class="modal-sec3">
                <form>
                  <div class="form-group proEmail">
                    <label for="proEmail"
                      >{{
                        getUiText("app-prospect-landing-verify-email-heading-1")
                      }}
                    </label>
                    <input
                      id="proEmail"
                      ref="proEmail"
                      v-model="prospectData.email"
                      data-cy="psp-home-email"
                      type="email"
                      autocomplete="false"
                      class="form-control"
                      :placeholder="emailPrompt"
                      :class="!emailValid ? 'invalid-input' : ''"
                      tabindex="0"
                      @keydown.enter="prospectFormOnKeyUp"
                      @blur="inputBlur('EMAIL')"
                    />
                    <div
                      class="error-msg"
                      :class="!emailValid ? 'mg-top-19' : ''"
                      :v-if="!emailValid || null"
                    >
                      <span>{{ emailValidationMsg }}</span>
                    </div>
                  </div>
                  <div class="form-group proDomain">
                    <label for="proDomain"
                      >{{
                        getUiText(
                          "app-prospect-landing-verify-domain-heading-1",
                        )
                      }}
                    </label>
                    <input
                      id="proDomain"
                      v-model="prospectData.org_domain"
                      data-cy="psp-home-domain"
                      type="domain"
                      autocomplete="false"
                      class="form-control"
                      :placeholder="
                        getComponentUiText(
                          'app-prospect-landing-verify-domain-prompt-1',
                        )
                      "
                      :class="!domainValid ? 'invalid-input' : ''"
                      @keydown.enter="prospectFormOnKeyUp"
                      @blur="inputBlur('DOMAIN')"
                    />
                    <div
                      class="error-msg"
                      :class="
                        !domainValid || domainValidationMsg ? 'mg-top-25' : ''
                      "
                      :v-if="!domainValid || domainValidationMsg !== '' || null"
                    >
                      <span>{{ domainValidationMsg }}</span>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-sec4">
                {{
                  getUiText("app-prospect-landing-verify-email-domain-match-1")
                }}
              </div>
              <div class="modal-sec5">
                <button
                  type="button"
                  data-cy="psp-home-getstarted-button"
                  class="btn btn-primary getstarted-button"
                  :class="loader ? 'disable-click' : ''"
                  :disabled="disableButton"
                  tabindex="3"
                  @click="saveProspect"
                >
                  <div v-if="loader || null" class="loader">
                    <span class="spinner-border" role="status" />
                    <span class="spinner-text"
                      >{{ getUiText("app-nav-button-loading-text") }}...</span
                    >
                  </div>
                  <span v-else>{{
                    getUiText(
                      "app-prospect-landing-verify-button-get-started-1",
                    )
                  }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="modal-sec6">
              <div class="modal-sec6-sec1">
                <v-runtime-template :template="footerText" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-facing-decorator";
import HeaderLogo from "@/components/common/headerLogo.vue";
import ProspectService from "@/services/prospect/prospectService";
import $ from "jquery";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import errorhandler from "@/components/common/exceptionHandler.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import { useRoute } from "vue-router";
import store from "@/store";
import { Modal } from "bootstrap";

@Component({
  components: {
    headerlogo: HeaderLogo,
    errorhandler,
    VRuntimeTemplate,
  },
})
export default class ProspectHome extends Vue {
  prospectData = { email: "", org_domain: "" };
  prospectSaveData = { email: "", org_domain: "" };
  disableButton = true;
  showProspectCallbackError = false;
  prospectCallbackErrorMsg = "";
  emailValid = true;
  emailValidationMsg = "";
  domainValid = true;
  domainValidationMsg = "";
  showProspectForm = false;
  emailFieldFocus = 0;
  orgFieldFocus = 0;
  emailValidSilent = true;
  domainValidSilent = true;
  windowHeight = "";
  domainsList: any = [];
  loader = false;
  isFailVerified = false;
  passphraseStatus = false;
  passphrase = "";
  passphraseValid = false;

  passphrasePrompt = "";
  emailPrompt = "";
  domainPrompt = "";
  footerTextTags: any = {
    "app-prospect-landing-verify-button-get-started-1": {
      openTag: "<strong>'",
      closeTag: "'</strong>",
    },
    "app-prospect-landing-verify-footer-link-tc-1": {
      openTag: `<a href="${process.env.VUE_APP_CS_CORP_SITE_URL}/${process.env.VUE_APP_PATH_TERMS_AND_CONDITIONS}">`,
      closeTag: "</a>",
    },
    "app-prospect-landing-verify-footer-link-pp-1": {
      openTag: `<a href="${process.env.VUE_APP_CS_CORP_SITE_URL}/${process.env.VUE_APP_PATH_PRIVACY_POLICY}">`,
      closeTag: "</a>",
    },
  };

  footerText = "";
  prospectModalInstance: any = null;

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  created() {
    // ProspectCallBack -> ErrorInfo : To show error which is occured and stored in 'prospectCallback' page.
    if (
      sessionStorage.getItem("prospectCallbackErrorInfo") &&
      sessionStorage.getItem("prospectCallbackErrorInfo") !== ""
    ) {
      this.showErrorInfo(
        "" + sessionStorage.getItem("prospectCallbackErrorInfo"),
      );
    }
    sessionStorage.getItem("sessionStarted") === "true" &&
      this.prospectLogout();
    sessionStorage.clear();
    this.setInitials();
  }
  mounted() {
    const route = useRoute();
    const queryParam = route.query.openModal;
    window.addEventListener("keyup", this.keyPressed);

    const prospectModal = document.getElementById("prospectModal");
    if (prospectModal) {
      this.prospectModalInstance = new Modal(prospectModal);
      prospectModal.addEventListener("show.bs.modal", this.openProspectForm);
      prospectModal.addEventListener("hidden.bs.modal", this.clearProspectForm);
    }
    if (queryParam === "true") {
      this.prospectModalInstance?.show();
    }

    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }

    this.$nextTick(() => {
      window.addEventListener("resize", this.onWindowResize);
      setTimeout(() => {
        this.onWindowResize();
        $(this.$refs.passphraseCodeFeild as any).focus();
        this.updateUIVariables();
      }, 100);
      this.resetStoreData();
    });
  }

  @Watch("prospectData.email")
  onChangeEmail() {
    this.showProspectForm && this.validateEmail();
  }

  @Watch("prospectData.org_domain")
  onChangeDomain() {
    this.showProspectForm && this.validateOrg();
  }

  @Watch("passphrase")
  onChangepassphrase() {
    this.passphraseStatus = this.passphrase.length > 0;
  }

  @Watch("languageSelected")
  onChangeLanguageSelected() {
    setTimeout(() => {
      this.updateUIVariables();
    }, 50);
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }
  getProcessedUIText(id: string, tags: any) {
    return Utils.getProcessedUIText(
      id,
      tags,
      this.languageSelectedText,
      this.defaultUiText,
    );
  }
  getComponentUiText(id: string, isArray = false) {
    return Utils.getComponentUiText(id, isArray);
  }

  updateUIVariables() {
    this.passphrasePrompt = this.getUiText(
      "app-prospect-landing-preview-prompt-1",
    );
    this.emailPrompt = this.getUiText(
      "app-prospect-landing-verify-email-prompt-1",
    );
    this.domainPrompt = this.getUiText(
      "app-prospect-landing-verify-domain-prompt-1",
    );
    this.footerText =
      "<span>" +
      this.getProcessedUIText(
        "app-prospect-landing-verify-footer-text-1",
        this.footerTextTags,
      ) +
      "</span>";
  }

  prospectLogout() {
    try {
      const prospectService = new ProspectService();
      prospectService.logout().then(() => {
        store.dispatch("Prospect/unauthenticateProspect");
        store.dispatch("Prospect/unsetPreProspectSession");
      });
    } catch (error) {
      console.log("Error in prospectLogout", error);
    }
  }

  letsgo() {
    if (!this.isFailVerified) {
      // ($("#prospectModal") as any).modal("show");
      const prospectModal = document.getElementById("prospectModal");
      if (prospectModal) {
        const modal = new Modal(prospectModal);
        modal.show();
      }
      return;
    }
    if (this.passphrase === "") {
      return;
    }
    const prospectService = new ProspectService();
    prospectService.verifyPassphrase(this.passphrase).then(
      (response: any) => {
        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.message &&
          response.data.message.toLowerCase() === "success"
        ) {
          // this.prospectModalInstance?.show();
          setTimeout(() => {
            this.reSavePropect();
          }, 500);
          // this.prospectModalInstance?.show();
          this.passphraseValid = true;
        }
      },
      (error: any) => {
        this.passphraseValid = false;
        if (
          error &&
          error.status &&
          error.data &&
          error.data.error &&
          error.data.error.message
        ) {
          this.showErrorInfo(error.data.error);
        } else if (error.data.message === "invalid csrf token") {
          this.$router.go(0);
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }
  resetStoreData() {
    this.$store.dispatch("ProspectQuestions/setAllToDefaultData"); // To clear existing data in store.
    sessionStorage.clear(); // To clear sessionStorage data.
  }
  async validateEmail() {
    this.prospectData.email = this.prospectData.email.toLowerCase();
    const emailSplits = this.prospectData.email.split("@");

    if (!Utils.IsEmailValid(this.prospectData.email)) {
      if (this.emailFieldFocus > 0) {
        this.emailValid = false;
        this.emailValidationMsg = this.getUiText(
          "app-prospect-error-invalid-email",
        );
      }
      this.emailValidSilent = false;
    } else {
      if (Utils.IsDomainNameValidCustom(emailSplits[1])) {
        this.emailValid = true;
        this.emailValidationMsg = "";
        this.emailValidSilent = true;
      } else {
        if (this.emailFieldFocus > 0) {
          this.emailValid = false;
          this.emailValidationMsg = this.getUiText(
            "app-prospect-error-invalid-email",
          );
        }
        this.emailValidSilent = false;
      }
    }

    if (this.emailValid && emailSplits.length === 2) {
      const isExist =
        this.domainsList && this.domainsList.indexOf(emailSplits[1]);
      if (isExist > -1) {
        if (this.emailFieldFocus > 0) {
          this.emailValid = false;
          this.emailValidationMsg = this.getUiText(
            "app-prospect-error-domain-email-service-provider",
          );
        }
        this.emailValidSilent = false;
      }

      await this.validateFurther();
    }
    this.checkVals();
  }
  async validateOrg() {
    this.prospectData.org_domain = this.prospectData.org_domain.toLowerCase();
    if (!Utils.IsDomainNameValid(this.prospectData.org_domain)) {
      if (this.orgFieldFocus > 0) {
        this.domainValidationMsg = this.getUiText(
          "app-prospect-error-invalid-domain-name",
        );
        this.domainValid = false;
      }
      this.domainValidSilent = false;
    } else {
      if (!Utils.IsDomainNameValidCustom(this.prospectData.org_domain)) {
        if (this.orgFieldFocus > 0) {
          this.domainValidationMsg = this.getUiText(
            "app-prospect-error-invalid-domain-name",
          );
          this.domainValid = false;
        }
        this.domainValidSilent = false;
      } else {
        this.domainValidationMsg = "";
        this.domainValid = true;
        this.domainValidSilent = true;
      }
    }
    if (this.domainValid) {
      await this.validateFurther();
    }
    this.checkVals();
  }

  validateFurther() {
    const emailSplits = this.prospectData.email
      ? this.prospectData.email.split("@")
      : "";
    if (
      !emailSplits ||
      emailSplits.length !== 2 ||
      !emailSplits[1] ||
      (this.prospectData.org_domain &&
        emailSplits[1] !== this.prospectData.org_domain)
    ) {
      if (this.orgFieldFocus > 0) {
        this.domainValidationMsg = this.getUiText(
          "app-prospect-error-org-domain-email-domain-mismatch",
        );
      }
      this.domainValidSilent = false;
    } else {
      this.domainValidationMsg = "";
      this.domainValidSilent = true;
    }
  }
  onWindowResize() {
    if (window.innerHeight > 750) {
      if (window.innerHeight < 850) {
        if (window.innerHeight < window.innerWidth) {
          this.windowHeight = "100% !important" as string;
        } else {
          this.windowHeight = (window.innerHeight -
            80 +
            "px !important") as string;
        }
      } else if (window.innerHeight < 900) {
        this.windowHeight = (window.innerHeight +
          30 +
          "px !important") as string;
      } else {
        if (window.innerHeight > 1000 && window.innerWidth > 1000) {
          this.windowHeight = (window.innerHeight -
            200 +
            "px !important") as string;
        } else {
          this.windowHeight = (window.innerHeight -
            120 +
            "px !important") as string;
        }
      }
    } else {
      this.windowHeight = "100% !important" as string;
    }
  }
  async setInitials() {
    await this.getV3Recaptcha();
  }
  inputBlur(inputIs: string) {
    if (inputIs === "EMAIL") {
      this.emailFieldFocus++;
      this.validateEmail();
    } else if (inputIs === "DOMAIN") {
      this.orgFieldFocus++;
      this.validateOrg();
    }
  }
  checkVals() {
    if (this.prospectData.org_domain != "" && this.prospectData.email != "") {
      let checker =
        this.prospectData.email.split("@")[1] === this.prospectData.org_domain;
      if (
        checker &&
        this.emailValidationMsg === "" &&
        this.domainValidationMsg === ""
      ) {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
    } else {
      this.disableButton = true;
    }
  }
  openProspectForm() {
    this.showProspectForm = true;

    this.$nextTick(() => {
      setTimeout(() => {
        (this.$refs.proEmail as any).focus();
      }, 500);
    });
  }

  clearProspectForm() {
    this.showProspectForm = false;
    this.prospectData = { email: "", org_domain: "" };
    this.emailValid = true;
    this.emailValidationMsg = "";
    this.domainValidationMsg = "";
    this.domainValid = true;
    this.emailFieldFocus = 0;
    this.orgFieldFocus = 0;
    this.emailValidSilent = true;
    this.domainValidSilent = true;
    this.disableButton = true;
    this.loader = false;
    this.passphraseValid = false;
  }

  prospectFormOnKeyUp() {
    if (!this.disableButton) {
      this.saveProspect();
    }
  }

  async getRecaptcha() {
    try {
      const finalKey = await Utils.getV3Recaptcha();
      const recaptcha = await load(`${finalKey}`, {
        autoHideBadge: true,
      });
      const token = await recaptcha.execute("submit");
      return token;
    } catch (error: any) {
      console.log(error);
    }
  }

  async saveProspect() {
    if (this.prospectData.email && this.prospectData.org_domain) {
      this.loader = true;
      await this.validateEmail();
      await this.validateOrg();

      if (!this.emailValid || !this.domainValid || this.domainValidationMsg) {
        this.loader = false;
        return false;
      }
      this.prospectSaveData = this.prospectData;
      const prospectService = new ProspectService();
      const recaptcha = await this.getRecaptcha();
      prospectService.saveProspectVerify(this.prospectData, recaptcha).then(
        (response: any) => {
          localStorage.removeItem("csrfReloadDone");
          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.message &&
            response.data.message.toLowerCase() === "success"
          ) {
            sessionStorage.setItem(
              "prospectEmail",
              "" + this.prospectData.email,
            );
            this.prospectModalInstance?.hide();
            store.dispatch("Prospect/setPreProspectSession");
            this.$router.push({ path: "/prospectEmailThanks" });
          }
        },
        (error: any) => {
          this.loader = false;
          if (
            error.status === 422 &&
            error.data.error.type.toLowerCase() === "exc_preview_auth_fail-1"
          ) {
            this.isFailVerified = true;
            this.showErrorInfo(error.data.error);
            const prospectModal = document.getElementById("prospectModal");
            if (prospectModal) {
              const modal =
                Modal.getInstance(prospectModal) || new Modal(prospectModal);
              modal.hide();
            }
          } else if (
            error &&
            error.status &&
            error.data &&
            error.data.error &&
            error.data.error.message
          ) {
            this.showErrorInfo(error.data.error);
          } else if (
            error.data.message.toLowerCase() === "invalid csrf token"
          ) {
            this.$router.go(0);
          } else {
            this.showErrorInfo(error.data);
          }
        },
      );
    }
  }

  async reSavePropect() {
    const prospectService = new ProspectService();
    const recaptcha = await this.getRecaptcha();
    prospectService.saveProspectVerify(this.prospectSaveData, recaptcha).then(
      (response: any) => {
        localStorage.removeItem("csrfReloadDone");
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.message &&
          response.data.message.toLowerCase() === "success"
        ) {
          sessionStorage.setItem(
            "prospectEmail",
            "" + this.prospectSaveData.email,
          );
          store.dispatch("Prospect/setPreProspectSession");
          this.$router.push({ path: "/prospectEmailThanks" });
        }
      },
      (error: any) => {
        this.loader = false;
        if (
          error &&
          error.status &&
          error.data &&
          error.data.error &&
          error.data.error.message
        ) {
          this.showErrorInfo(error.data.error);
        } else if (error.data.message.toLowerCase() === "invalid csrf token") {
          this.$router.go(0);
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }

  keyPressed(e: any) {
    if (e.keyCode == 13 && !this.showProspectForm) {
      if (
        this.passphraseStatus &&
        this.passphraseValid &&
        !this.isFailVerified
      ) {
        this.prospectModalInstance?.show();
      } else {
        this.letsgo();
      }
    }
  }

  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }
  closeProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }
  async setRecaptchaInfo(captchaSiteKey: any) {
    const recaptcha = await load(`${captchaSiteKey}`);
    recaptcha.execute("submit").then((token) => {
      this.getDomainsList(token);
    });
    recaptcha.execute("submit").then((token) => {
      this.$store.dispatch("LanguagePicker/setLanguages", token);
    });
    recaptcha.execute("submit").then((token) => {
      this.$store.dispatch("LanguagePicker/setLanguageList", token);
    });
  }
  getV3Recaptcha() {
    Utils.getV3Recaptcha().then(
      (finalKey: any) => {
        this.setRecaptchaInfo(finalKey);
      },
      (error: any) => {
        if (
          error &&
          error.status &&
          error.data &&
          error.data.error &&
          error.data.error.message
        ) {
          this.showErrorInfo(error.data.error);
        } else if (error.data.message.toLowerCase() === "invalid csrf token") {
          this.$router.go(0);
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }

  getDomainsList(token: any) {
    const prospectService = new ProspectService();
    prospectService.getDomainsList(token).then(
      (res: any) => {
        if (res && res.data && res.data.data && res.data.data.length > 0) {
          this.domainsList = res.data.data;
        }
      },
      (error: any) => {
        if (error && error.status == 400 && error.data && error.data.message) {
          this.showErrorInfo(error.data);
        } else if (
          error &&
          error.status &&
          error.data &&
          error.data.error &&
          error.data.error.type
        ) {
          this.showErrorInfo(error.data.error);
        }
      },
    );
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }
  beforeUnmount() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }
    window.removeEventListener("keyup", this.keyPressed);
  }
}
</script>
<style lang="scss" scoped>
.content-sec1 {
  font-style: normal;
  font-weight: 500;
  font-size: 42px;
  line-height: 140%;
  color: #231f20;
  //width: 90%;
}
.content-sec2 {
  position: relative;
  top: 26px;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 170%;
  color: #231f20;
  //width: 85%;
}

.custom-align {
  display: flex;
}
.letsgo-button {
  width: 118px;
  height: 41px;
  background: #0345bd;
  box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
  border-radius: 26.9091px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.content-sec2-enter-block {
  margin-top: 7px;
}
.enter-text {
  top: 47px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: contents;
  align-items: center;
  color: #231f20;
}
.enter-icon {
  margin-top: -5px;
  margin-left: 6px;
}
.modal-welcome {
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 39px;
  color: #211f58;
}
.modal-sec2 {
  position: relative;
  margin-top: 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #231f20;

  .form-group label {
    position: relative;
    width: 202px;
    height: 18px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #231f20;
  }
}
.modal-sec4 {
  width: 80%;
  margin-top: 22px;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 150%;
  color: #878787;
}
.modal-sec5 {
  margin-top: 47px;
  position: relative;
  padding-left: 1px;
}
.getstarted-button {
  min-width: 173px;
  width: fit-content;
  height: 45px;
  padding: 0px 20px;
  left: 72px;
  box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
  border-radius: 29.4638px;
  background: #0345bd;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  text-transform: uppercase;
}
.modal-footer {
  padding: 0px !important;
  border-top: none;
  margin: 0px !important;
}
.modal-footer > * {
  margin: 0px !important;
}
.modal-header {
  justify-content: flex-end;
  border-bottom: none;
}
.modal-header .close {
  padding: 0px !important;
}
.modal-sec6 {
  width: 100%;
  height: auto;
  background: linear-gradient(
    180deg,
    rgba(230, 230, 230, 0.38) 0%,
    #ffffff 58.06%
  );
  opacity: 0.8;
  box-shadow: inset 0px 2px 4px rgba(33, 31, 88, 0.03);
  border-radius: 0px 0px 6px 6px;

  .modal-sec6-sec1 {
    padding: 27px 70px 26px 71px;
    position: relative;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #231f20;
    a {
      text-decoration: underline;
    }
  }
}
.m-top-47 {
  margin-top: 47px;
  position: relative;
}
.modal-active {
  display: block;
}
.modal-sec3 {
  margin-top: 48px;
  position: relative;

  .form-control,
  .form-control:focus {
    border: 0px;
    border-left: 1px solid #ced4da;
    padding-left: 20px;
    color: #0345bd;
    box-shadow: none;
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 33px;
    border-radius: 0px !important;
  }
  ::placeholder {
    color: #b7b7b7;
    font-size: 22px;
  }
  .form-group label {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #231f20;
  }
  .form-group #proEmail {
    top: 18px;
    position: static;
  }
  .proDomain {
    margin-top: 52px;
    position: relative;
  }
}
.show {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-sec5 button:disabled {
  color: #ffffff;
  background: #eeeff0;
  border-color: #eeeff0;
}
.modal-dialog {
  max-width: 630px;
}
.modal-fade {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #fff;
  opacity: 0.9;
}
.error-div {
  margin-top: 60px;
  position: relative;
  text-align: left;
}
.member-modal-title {
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 39px;
  color: #211f58;
}
.member-modal-sec2 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #231f20;
  display: grid;
  height: 112px;
  top: 15px;
  position: relative;
}
.member-modal-close button img {
  width: 19.09px;
  height: 19.09px;
}
.member-modal-sec1 {
  padding: 10px 60px 60px 43px;
}
.org-modal-close button img {
  width: 19.09px;
  height: 19.09px;
}
.org-modal-sec1 {
  padding: 10px 60px 60px 43px;

  .org-modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 39px;
    color: #211f58;
  }
  .org-modal-sec2 {
    top: 15px;
    position: relative;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    color: #231f20;
    display: grid;
  }
  .org-modal-sec3 {
    top: 22px;
    position: relative;
  }
}

.modal-body-padding {
  padding: 13px 70px 55px 70px;
}
.mg-top-25 {
  margin-top: 25px;
  position: relative;
}
.mg-top-19 {
  margin-top: 19px;
  position: relative;
}

.modal-body {
  padding: 0px;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;

  .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
  .spinner-text {
    padding-left: 1rem;
    text-transform: none;
  }
}

.disable-click {
  pointer-events: none;
}

.passphrase {
  .form-control,
  .form-control:focus {
    border: 0px;
    border-left: 1px solid rgba(183, 183, 183, 0.3);
    padding-left: 20px;
    color: #0345bd;
    box-shadow: none;
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 33px;
    border-radius: 0px !important;
    background: inherit;
  }
  ::placeholder {
    color: #b7b7b7;
    font-size: 22px;
  }
  .form-group label {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #231f20;
  }
}
.content-sec4 {
  font-size: 13px;
  line-height: 19px;
  color: #878787;
  max-width: 358px;
  padding: 10px 10px 10px 0px;
}

@media (min-width: 3840px) {
  .loader {
    .spinner-border {
      width: 3rem;
      height: 3rem;
    }
    .spinner-text {
      padding-left: 2rem;
    }
  }
  .form-control::placeholder {
    font-size: 38px !important;
  }
  .passphrase {
    .form-control,
    .form-control:focus {
      border-left: 2px solid rgba(183, 183, 183, 0.3);
      padding-left: 40px;
      font-size: 44px;
      line-height: 66px;
    }
    .form-group label {
      font-size: 24px;
      line-height: 36px;
    }
    ::placeholder {
      font-size: 44px;
    }
  }
  .content-sec4 {
    font-size: 26px;
    line-height: 38px;
    max-width: 716px;
    padding: 20px 20px 20px 0px;
  }
}
</style>
